import { pipelineConstants } from '../_constants';
import { pipelineService } from '../_services';

export const pipelineActions = {
   launchPipeline 
};

function launchPipeline(token, sport) {
    return dispatch => {
        dispatch(request());

        pipelineService.launchPipeline(token, sport)
            .then(
                launchId => dispatch(success(launchId)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: pipelineConstants.LAUNCH_PIPELINE_REQUEST } }
    function success(launchId) { return { type: pipelineConstants.LAUNCH_PIPELINE_SUCCESS, launchId } }
    function failure(error) { return { type: pipelineConstants.LAUNCH_PIPELINE_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/pipeline.js